package io.eqoty.shared.datalayer.objects

data class AesCredentials(val iv: UByteArray, val key: UByteArray)